import { Col, Row } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  BUILDING_REQUIRED_FIELDS_LOOKUP,
  BUILDING_TABS_KEYS,
  FORM_FIELDS_LOOKUP,
  FORM_FIELDS_TYPE,
  HELPER_TEXT_KEYS,
  PROPERTY_KEY_FEATURE_TEMPLATE_KEYS,
} from "../../utils/constants";
import { validateMarketingDescription } from "../../utils/utils";
import KeyAdvantagesCharacteristics from "../../components/KeyAdvantagesCharacteristics/KeyAdvantagesCharacteristics";
import KeyFeature from "../../components/KeyFeature/KeyFeature";

const KeyFeatures = ({
  viewOnlyMode,
  form,
  templateList,
  auditPanelDrawerVisible,
  isPropertySearchRedesign,
  characteristics,
}) => {
  const { lookupList } = useSelector(state => state.helperText);
  const { t } = useTranslation();

  const fieldsType = FORM_FIELDS_TYPE.regular;
  const keyFeatureColProps = isPropertySearchRedesign ? { span: 12, xs: 24, sm: 12, lg: 12 } : {};

  const renderFields = () => (
    <>
      <Row className="fields-row" gutter={20}>
        <KeyFeature
          colProps={keyFeatureColProps}
          parentId="buildingInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.building.keyFeature1]}
          tab={BUILDING_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.building.keyFeatures.feature1.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          label="KeyFeatures.KeyFeature1"
          name={["keyFeatures", "feature1"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature1.templateKey]}
          rules={[
            {
              required: BUILDING_REQUIRED_FIELDS_LOOKUP[fieldsType].keyFeatures.feature1,
              message: t("BuildingInfo.KeyFeature1RulesMessage"),
            },
            {
              whitespace: true,
              message: t("BuildingInfo.KeyFeature1WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature1")),
            },
          ]}
        />
        <KeyFeature
          colProps={keyFeatureColProps}
          parentId="buildingInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.building.keyFeature2]}
          tab={BUILDING_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.building.keyFeatures.feature2.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          label="KeyFeatures.KeyFeature2"
          name={["keyFeatures", "feature2"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature2.templateKey]}
          rules={[
            {
              required: BUILDING_REQUIRED_FIELDS_LOOKUP[fieldsType].keyFeatures.feature2,
              message: t("BuildingInfo.KeyFeature2RulesMessage"),
            },
            {
              whitespace: true,
              message: t("BuildingInfo.KeyFeature2WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature2")),
            },
          ]}
        />
        <KeyFeature
          colProps={keyFeatureColProps}
          parentId="buildingInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.building.keyFeature3]}
          tab={BUILDING_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.building.keyFeatures.feature3.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          label="KeyFeatures.KeyFeature3"
          name={["keyFeatures", "feature3"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature3.templateKey]}
          rules={[
            {
              required: BUILDING_REQUIRED_FIELDS_LOOKUP[fieldsType].keyFeatures.feature3,
              message: t("BuildingInfo.KeyFeature3RulesMessage"),
            },
            {
              whitespace: true,
              message: t("BuildingInfo.KeyFeature3WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature3")),
            },
          ]}
        />
      </Row>
      <Row className="fields-row" gutter={20}>
        <KeyFeature
          colProps={keyFeatureColProps}
          parentId="buildingInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.building.keyFeature4]}
          tab={BUILDING_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.building.keyFeatures.feature4.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          label="KeyFeatures.KeyFeature4"
          name={["keyFeatures", "feature4"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature4.templateKey]}
          rules={[
            {
              whitespace: true,
              message: t("BuildingInfo.KeyFeature4WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature4")),
            },
          ]}
        />
        <KeyFeature
          colProps={keyFeatureColProps}
          parentId="buildingInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.building.keyFeature5]}
          tab={BUILDING_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.building.keyFeatures.feature5.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          label="KeyFeatures.KeyFeature5"
          name={["keyFeatures", "feature5"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature5.templateKey]}
          rules={[
            {
              whitespace: true,
              message: t("BuildingInfo.KeyFeature5WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature5")),
            },
          ]}
        />
        <KeyFeature
          colProps={keyFeatureColProps}
          parentId="buildingInfo"
          templateList={templateList}
          form={form}
          viewOnlyMode={viewOnlyMode}
          tooltip={lookupList[HELPER_TEXT_KEYS.building.keyFeature6]}
          tab={BUILDING_TABS_KEYS[2]}
          fieldName={FORM_FIELDS_LOOKUP.building.keyFeatures.feature6.key}
          auditPanelDrawerVisible={auditPanelDrawerVisible}
          label="KeyFeatures.KeyFeature6"
          name={["keyFeatures", "feature6"]}
          templateName={["keyFeatures", PROPERTY_KEY_FEATURE_TEMPLATE_KEYS.feature6.templateKey]}
          rules={[
            {
              whitespace: true,
              message: t("BuildingInfo.KeyFeature6WhitespaceMessage"),
            },
            {
              max: 255,
            },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("KeyFeatures.KeyFeature6")),
            },
          ]}
        />
      </Row>
    </>
  );

  if (!isPropertySearchRedesign) {
    return renderFields();
  }

  return (
    <Row className="key-advantages-redesign" gutter={20}>
      <Col xs={24} lg={16} className="key-advantages-redesign__fields">
        {renderFields()}
      </Col>
      <Col xs={24} lg={8}>
        <KeyAdvantagesCharacteristics
          title={t("KeyAdvantagesCharacteristics.Title")}
          characteristics={characteristics}
        />
      </Col>
    </Row>
  );
};
KeyFeatures.propTypes = {
  viewOnlyMode: PropTypes.bool,
  form: PropTypes.object,
  templateList: PropTypes.array,
  auditPanelDrawerVisible: PropTypes.bool,
  isPropertySearchRedesign: PropTypes.bool,
  characteristics: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    }),
  ),
};
KeyFeatures.defaultProps = {
  isPropertySearchRedesign: false,
  characteristics: [],
};
export default KeyFeatures;
